/* CW ambient lights: the crowd, without the conversion.
   Self-mounts behind the Partners section. */
(function () {
  function mount(host, n) {
    if (!host || host.querySelector('.cw-lights')) return;
    host.classList.add('cw-lights-host');
    host.setAttribute('data-bg', 'ink');

    var cvs = document.createElement('canvas');
    cvs.className = 'cw-lights';
    host.insertBefore(cvs, host.firstChild);

    var ctx = cvs.getContext('2d');
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var DPR = Math.min(devicePixelRatio || 1, 2);
    var N = innerWidth < 760 ? Math.round(n * 0.5) : n;
    var W = 0, H = 0, pts = [], t = 0;

    function seed() {
      pts.length = 0;
      for (var i = 0; i < N; i++) {
        var d = Math.random(), near = 1 - d;
        pts.push({
          nx: -0.08 + Math.random() * 1.16,
          ny: 0.10 + Math.pow(1 - d, 1.6) * 0.96,
          near: near, s: 0.4 + near * 1.7,
          sway: 4 + near * 12, bob: 0.6 + near * 2.2,
          ph: Math.random() * Math.PI * 2,
          tw: Math.random() * Math.PI * 2,
          tws: 0.005 + Math.random() * 0.015,
          warmth: 0.82 + Math.random() * 0.18,
          rose: Math.random() < 0.07,
          flash: 0
        });
      }
    }

    function size() {
      W = cvs.clientWidth; H = cvs.clientHeight;
      if (!W || !H) return;
      cvs.width = W * DPR; cvs.height = H * DPR;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      if (!pts.length || Math.abs(W - (size._w || 0)) > 2 || Math.abs(H - (size._h || 0)) > 2) {
        size._w = W; size._h = H; seed();
      }
    }

    function frame() {
      t++;
      if (Math.random() < 0.11) { var f = pts[(Math.random() * N) | 0]; if (f) f.flash = 1; }

      ctx.clearRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'lighter';
      for (var i = 0; i < N; i++) {
        var p = pts[i]; if (!p) continue;
        var x = p.nx * W + Math.sin(t * 0.0075 + p.nx * 5.0) * p.sway;
        var y = p.ny * H + Math.sin(t * 0.011 + p.ph) * p.bob;

        p.tw += p.tws; p.flash *= 0.86;
        var twinkle = 0.62 + Math.sin(p.tw) * 0.38;
        var alpha = (0.20 + 0.42 * twinkle) * (0.38 + p.near * 0.62);
        var rad = p.s;
        if (p.flash > 0.02) { alpha = Math.min(1, alpha + p.flash * 0.8); rad *= 1 + p.flash * 2.4; }

        ctx.beginPath();
        ctx.fillStyle = p.rose ? 'rgba(204,136,153,' + alpha + ')'
          : 'rgba(' + ((252 * p.warmth) | 0) + ',' + ((238 * p.warmth) | 0) + ',' + ((224 * p.warmth) | 0) + ',' + alpha + ')';
        ctx.arc(x, y, rad, 0, 6.2832);
        ctx.fill();
      }
      ctx.globalCompositeOperation = 'source-over';
      if (!reduce) requestAnimationFrame(frame);
    }

    addEventListener('resize', size);
    size();
    requestAnimationFrame(frame);
  }

  function boot() { mount(document.querySelector('section.partners'), 420); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
